export default {
    // hostLogin: 'http://10.1.138.15:5086',   // 新登录注册接口
    // timeout: 10000,
    // MOCK: false,
}
